import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getServices } from '../../services/firebase/serviceService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faMapMarkerAlt, 
  faPhone, 
  faEnvelope, 
  faClock 
} from '@fortawesome/free-solid-svg-icons';
import { 
  faFacebookF, 
  faTwitter, 
  faInstagram, 
  faLinkedinIn 
} from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const servicesData = await getServices();
        setServices(servicesData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching services for footer:', error);
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  return (
    <footer className="bg-dark text-white py-5 enhanced-footer">
      <Container>
        <Row>
          <Col lg={3} md={6} className="mb-4 mb-lg-0">
            <h4 className="mb-4">Life and Wellness Center</h4>
            <p className="justified-text">Providing quality healthcare services with compassion and expertise since 2005.</p>
            <div className="d-flex gap-3 mt-3">
              <a href="https://www.facebook.com/profile.php?id=61573683579875" className="text-white social-icon" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <button className="text-white bg-transparent border-0 p-0 social-icon">
                <FontAwesomeIcon icon={faTwitter} />
              </button>
              <button className="text-white bg-transparent border-0 p-0 social-icon">
                <FontAwesomeIcon icon={faInstagram} />
              </button>
              <button className="text-white bg-transparent border-0 p-0 social-icon">
                <FontAwesomeIcon icon={faLinkedinIn} />
              </button>
            </div>
          </Col>
          <Col lg={3} md={6} className="mb-4 mb-lg-0">
            <h4 className="mb-4">Quick Links</h4>
            <ul className="list-unstyled">
              <li className="mb-2"><Link to="/" className="text-white footer-link">Home</Link></li>
              <li className="mb-2"><Link to="/#about" className="text-white footer-link">About Us</Link></li>
              <li className="mb-2"><Link to="/#services" className="text-white footer-link">Services</Link></li>
              <li className="mb-2"><Link to="/#provider" className="text-white footer-link">Our Teams</Link></li>
              <li className="mb-2"><Link to="/#stories" className="text-white footer-link">Testimonials</Link></li>
              <li className="mb-2"><Link to="/#financing" className="text-white footer-link">Financing Options</Link></li>
              <li className="mb-2"><Link to="/#contact" className="text-white footer-link">Contact</Link></li>
            </ul>
          </Col>
          <Col lg={3} md={6} className="mb-4 mb-lg-0">
            <h4 className="mb-4">Our Services</h4>
            <ul className="list-unstyled">
              {loading ? (
                <li className="mb-2">Loading services...</li>
              ) : services.length > 0 ? (
                services.map((service) => (
                  <li key={service.id} className="mb-2">
                    <Link to="/#services" className="text-white footer-link">{service.title}</Link>
                  </li>
                ))
              ) : (
                <li className="mb-2">No services available</li>
              )}
            </ul>
          </Col>
          <Col lg={3} md={6}>
            <h4 className="mb-4">Contact Us</h4>
            <ul className="list-unstyled">
              <li className="mb-3 d-flex">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2 mt-1" />
                <span>6010 E Highway 191, Suite 240, Odessa, Texas</span>
              </li>
              <li className="mb-3 d-flex">
                <FontAwesomeIcon icon={faPhone} className="me-2 mt-1" />
                <span>(432) 653-5487</span>
              </li>
              <li className="mb-3 d-flex">
                <FontAwesomeIcon icon={faEnvelope} className="me-2 mt-1" />
                <span>lifeandwellnesscenter78@gmail.com</span>
              </li>
              <li className="mb-3 d-flex">
                <FontAwesomeIcon icon={faClock} className="me-2 mt-1" />
                <span>Mon-Fri: 9:00 AM - 5:00 PM</span>
              </li>
            </ul>
          </Col>
        </Row>
        <hr className="my-4" />
        <div className="text-center">
          <p className="mb-0">&copy; {new Date().getFullYear()} Life and Wellness Center. All Rights Reserved.</p>
        </div>
        {/* Admin login link removed as requested */}
      </Container>
    </footer>
  );
};

export default Footer;